import axios from 'axios'
import {
	MessageBox,
	Message
} from 'element-ui'
import {
	Loading
} from 'element-ui'


// 请求实例
const instance = axios.create({
	baseURL: process.env.VUE_APP_BASE_API,
	timeout: 600000,
})

// 请求前置过滤器
instance.interceptors.request.use(
	config => {
		return config
	},
	error => {
		return Promise.reject(error)
	}
)

// 响应数据拦截并做通用处理
instance.interceptors.response.use(
	response => {
		const res = response.data
		// 下载文件直接返回
		if (response.headers['content-type'].includes('application/octet-stream')) {
			return res
		}

		if (response.headers['content-type'] === 'application/vnd.ms-excel') {
			return res
		}
		// 0为正确响应码
		if (res.code == 200) {
			return res
		} else if (res.code == 401) {
			Message({
				message: "Unauthorized 需要通过HTTP认证，或认证失败",
				type: 'error',
				duration: 3 * 1000,
				offset: 100,
			})
		} else if (res.code == 403) {
			Message({
				message: "Forbidden 请求资源被拒绝",
				type: 'error',
				duration: 3 * 1000,
				offset: 100,
			})
		} else if (res.code == 404) {
			Message({
				message: "Not Found 无法找到请求资源（服务器无理由拒绝）",
				type: 'error',
				duration: 3 * 1000,
				offset: 100,
			})
		} else if (res.code == 404) {
			Message({
				message: "Internal Server Error 服务器故障或Web应用故障",
				type: 'error',
				duration: 3 * 1000,
				offset: 100,
			})
		} else {
			return res
		}
		// else if(res.code==400){
		// 	Message({
		// 		message: "请先登录",
		// 		type: 'error',
		// 		duration: 3 * 1000,
		// 		offset: 100,
		// 	})
		// } else {
		// 	Message({
		// 		message: "请求异常",
		// 		type: 'error',
		// 		duration: 3 * 1000,
		// 		offset: 100,
		// 	})
		// }


	},
	error => {
		let {
			message
		} = error;
		if (message == "Network Error") {
			message = "您的网络不给力，请稍后再试";
		} else if (message.includes("timeout")) {
			message = "您的网络不给力，请稍后再试";
		} else if (message.includes("Request failed with status code 500")) {
			message = "服务端异常";
		} else if (message.includes("Request failed with status code 400")) {
			message = "客户端请求异常";
		}
		Message({
			message: message,
			type: 'error',
			duration: 3 * 1000,
			offset: 100,
		})
		return Promise.reject(error)
	}
)

/**
 * 上传
 * @param url
 * @param data
 */
export function upload(url, file, data) {
	const formData = new FormData()
	formData.append('file', file)

	// 附加数据
	if (data) {
		Object.keys(data).forEach((key) => {
			formData.append(key, data[key])
		})
	}
	return new Promise((resolve, reject) => {
		// 打开
		// const loading = Loading.service({
		// 	text: '正在上传数据...',
		// 	background: 'rgba(0, 0, 0, 0.7)'
		// })

		instance.request({
			url: url,
			method: 'post',
			headers: {
				'Content-Type': 'multipart/form-data',
			},
			data: formData,
			responseType: 'blob',
			timeout: 120000000
		}).then(response => {
			console.log(response)
			// loading.close()
			resolve(response)
		}).catch(err => {
			// loading.close()
			console.log(err)
			reject(err)
		})
	})
}

/**
 * 下载
 * @param url
 * @param data
 */
export function download(url, data, fileName) {
	let _fileName = fileName
	return new Promise((resolve, reject) => {
		// 打开
		const loading = Loading.service({
			text: '正在下载数据...',
			background: 'rgba(0, 0, 0, 0.7)'
		})

		instance.request({
			url: url,
			method: 'post',
			data: data,
			timeout: 1200000,
			responseType: 'blob'
		}).then(res => {
			loading.close()
			const content = res
			const blob = new Blob([content])
			const fileName = _fileName
			if ('download' in document.createElement('a')) { // 非IE下载
				const elink = document.createElement('a') //创建一个a标签通过a标签的点击事件区下载文件
				elink.download = fileName
				elink.style.display = 'none'
				elink.href = URL.createObjectURL(blob) //使用blob创建一个指向类型数组的URL
				document.body.appendChild(elink)
				elink.click()
				URL.revokeObjectURL(elink.href) // 释放URL 对象
				document.body.removeChild(elink)
			} else { // IE10+下载
				navigator.msSaveBlob(blob, fileName)
			}
		}).catch(err => {
			loading.close()
			reject(err)
		})
	})
}

/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */
export function post(url, data = {}) {
	return new Promise((resolve, reject) => {
		instance.post(url, data)
			.then(response => {
				resolve(response)
			}, err => {
				reject(err)
			})
	})
}

export function getres(url, params = {}) {
	return new Promise((resolve, reject) => {
		instance.get(url, params)
			.then(response => {
				resolve(response)
			}, err => {
				reject(err)
			})
	})
}
